import View from "../../../Account/Js/views/OrdersExpandView";
import components from "./components.js";
components.define("js-OrdersExpand", View);